jQuery(function($){

    if ($('.afrekenen-page').length == 0){
        return;
    }

    function initAfrekenen(){
        setTimeout(function(){
            $('#billing_postcode_field').insertBefore($('#billing_huisnummer_field'));
            $('#shipping_postcode_field').insertBefore($('#shipping_huisnummer_field'));
            $('.checkout-step[data-step=1]').addClass('active');
           // $(`<span class="t-underline open-address t-center flex-100 cursor">Adres handmatig invoeren</span>`).insertAfter($('#billing_address_1_field'));
           // $(`<span class="t-underline open-address t-center flex-100 cursor">Adres handmatig invoeren</span>`).insertAfter($('#shipping_address_1_field'));
        },0);

        
        
    }

    initAfrekenen();

    $(document).on('click', '.open-address', function(e){
        $(this).closest('div').find('#billing_address_1_field input, #shipping_address_1_field input').removeAttr('readonly').val('').focus().attr('placeholder', 'Straatnaam + huisnummer');
    });


    

    /* Validate the checkout form */
    $(document).on('change input', '.checkout-form input', function(e) {
        let formValid = true;
    
        // Get all required billing inputs
        let billingfields = $('.woocommerce-billing-fields .form-row.validate-required input');
    
        billingfields.each(function() {
            if (!$(this).val().trim()) {
                formValid = false;
                return false;
            }
        });
    
        // If shipping is checked, validate those fields too
        if ($('#ship-to-different-address-checkbox').is(':checked')) {
            let shippingfields = $('.woocommerce-shipping-fields .form-row.validate-required input');
    
            shippingfields.each(function() {
                if (!$(this).val().trim()) {
                    formValid = false;
                    return false;
                }
            });
        }
    
        // Enable or disable the button
        if (formValid) {
            $('.checkout-step[data-step=1] .btn').removeClass('disabled');
        } else {
            $('.checkout-step[data-step=1] .btn').addClass('disabled');
        }
    });
    
    $(document).on('click', '.offerte-aanvragen-btn', function(e) {
        e.preventDefault(); // Prevent default action
    
        let $form = $('form.checkout');
        let formData = $form.serializeArray(); 
    
        formData.push({ name: 'action', value: 'create_offerte_order' });
        formData.push({ name: '_wpnonce', value: wemake.nonce });
    
        $.ajax({
            url: wemake.ajax_url,
            type: 'POST',
            data: formData,
            success: function(response) {
                if (response.success) {
                    window.location.href = response.data.redirect_url;
                } else {
                    alert('Er ging iets mis: ' + response.data.message);
                }
            },
            error: function(xhr, status, error) {
                console.error('Fout bij offerte aanvraag:', error);
            }
        });
    });
    

    $(document).on('click', '.checkout-step__change', function(e) {
        let step = $(this).data('step');

        $('[data-step]').removeClass('active');
        $('[data-step=' + step + ']').addClass('active');
        $('[data-step=' + step + ']').removeClass('done');
        scrollToStep('[data-step=' + step + ']');
    });

    $(document).on('click', '.checkout-step__next', function(e) {
        e.stopPropagation();
        let nextStep = $(this).data('next-step');

        $('[data-step]').removeClass('active');
        $('[data-step=' + nextStep + ']').addClass('active');
        $('[data-step=' + (nextStep - 1) + ']').addClass('done');
        scrollToStep('.checkout-step[data-step=' + nextStep + ']');
    });

    function scrollToStep(stepSelector) {

        const $target = $(stepSelector);
        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top // 50px offset
            }, 0); // duration in ms
        }
    }
    



    let lastPaymentMethod = $('input[name="payment_method"]:checked').val();
    let lastShippingMethod = $('input[name^="shipping_method["]:checked').val();

    function updatePlaceOrderButton() {
        const $button = $('#place_order');
    
        if (!$button.length) return;
    
        // Get selected payment method label
        const $selected = $('input[name="payment_method"]:checked');
        let methodName = $selected.closest('li').find('label').data('title');
    
        if (!methodName) {
            methodName = ''; // fallback text
        }
    
        const text = 'Afrekenen met ' + methodName;
        const icon = '<img width="20" height="20" src="/wp-content/themes/wemake/images/checkout.svg" alt="">';
    
        $button
            .html(icon + $('<div>').text(text).html()) // safe HTML injection
            .addClass('btn btn--gold w-100 d-f gap-8 f-a-c');

        const currentPaymentMethod = $('input[name="payment_method"]:checked').val();
        const currentShippingMethod = $('input[name^="shipping_method["]:checked').val();

        if (currentPaymentMethod !== lastPaymentMethod) {
            lastPaymentMethod = currentPaymentMethod;
            $('.checkout-step[data-step=3]').addClass('active');
        }

        if (currentShippingMethod !== lastShippingMethod) {
            lastShippingMethod = currentShippingMethod;
            $('.checkout-step[data-step=2]').addClass('active');
        }

        $('.checkout-step[data-step=1] .btn').removeClass('no-events');

        updateCheckoutSummary();
        
    }


    $(document.body).on('updated_checkout', updatePlaceOrderButton);


    function updateCheckoutSummary(){
        $.ajax({
            url: wemake.ajax_url, 
            type: 'GET',
            data: {
                action: 'get_checkout_summary_html', 
                _wpnonce: wemake.nonce,
            },

            beforeSend: function(){
              //  $('.checkout-summary').html('<div class="spinner-loader"></div>');
            },

            success: function(response){
                $('.checkout-summary').html(response.data);
            },

            error: function(error) {
                console.error('Error displaying summary:', error);
            }
        });  
    }
}); 

